import React from 'react';
import { LoaderContainer, Spinner } from './styled';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Creators as GlobalsCreators } from 'store/globals/globals-duck.js';

const Loading = ({ isLoading }) => {
  return (
    isLoading && (
      <LoaderContainer>
        <Spinner />
      </LoaderContainer>
    )
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.Globals.isLoading,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(GlobalsCreators, dispatch);

Loading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Loading);
